import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=c7ff1146&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"
import style0 from "./forgot.vue?vue&type=style&index=0&id=c7ff1146&prod&lang=css"
import style1 from "./forgot.vue?vue&type=style&index=1&id=c7ff1146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ff1146",
  null
  
)

export default component.exports